import { render, staticRenderFns } from "./BatePapo.vue?vue&type=template&id=64b22984&scoped=true"
import script from "./BatePapo.vue?vue&type=script&lang=js"
export * from "./BatePapo.vue?vue&type=script&lang=js"
import style0 from "./BatePapo.vue?vue&type=style&index=0&id=64b22984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b22984",
  null
  
)

export default component.exports